import { jsx } from 'react/jsx-runtime';
import { Colors } from '../../../../theme/Colors.es.js';
import '../../../../theme/Shadows.es.js';
import '../../../../theme/Typography.es.js';

const skeletonBlock = "_skeleton-block_x6g5x_9";
const streakAnimation = "_streak-animation_x6g5x_1";
const styles = {
	skeletonBlock: skeletonBlock,
	streakAnimation: streakAnimation
};

const SkeletonBlock = ({ aspectRatio = void 0, borderRadius = "large", height = void 0, width = "100%", color = "GrayWarm2" }) => {
  const blockHeight = typeof height === "number" ? `${height}px` : height;
  const blockWidth = typeof width === "number" ? `${width}px` : width;
  return jsx("div", { className: styles.skeletonBlock, "data-border-radius": borderRadius, "data-testid": "SkeletonBlock", "data-zds": true, style: {
    "--skeleton-block-width": blockWidth,
    "--skeleton-block-padding-top": aspectRatio ? `calc(${width} / ${aspectRatio})` : blockHeight || 0,
    "--skeleton-block-background-color": Colors[color]
  } });
};

export { SkeletonBlock };
//# sourceMappingURL=SkeletonBlock.es.js.map
